var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWritingBuddyClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 438,
    viewBox: "0 0 562 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.445 218.07C535.206 218.918 541.396 219.694 546.767 220.339L549.53 211.812C542.816 209.974 535.587 207.975 529.36 206.178C523.978 204.626 495.869 200.066 477.164 198.08C450.526 195.252 413.396 195.103 395.869 196.059C361.289 197.945 284.746 217.496 237.765 230.249V241.321C284.675 228.588 373.707 209.653 406.712 207.853C422.977 206.966 448.965 208.973 475.706 211.812C494.278 213.784 512.874 216.116 528.445 218.07Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.368 228.832C186.577 228.099 207.297 229.388 228.802 231.477L230.609 217.77C209.093 215.68 186.968 214.246 172.602 215.044C155.409 216 126.235 221.244 95.9687 227.729C65.5497 234.246 33.5058 242.132 10.322 248.542L14.0022 261.852C36.9042 255.52 68.6844 247.697 98.8617 241.232C129.192 234.733 157.387 229.72 173.368 228.832Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.84 278.531C190.457 277.762 210.129 276.608 229.77 278.516L229.421 264.909C208.687 262.895 189.741 263.969 176.171 264.738C175.261 264.789 174.376 264.839 173.516 264.887C139.835 266.758 56.87 279.766 10.3215 292.637L14.0017 305.947C59.6247 293.332 141.613 280.49 174.282 278.675C175.116 278.629 175.969 278.581 176.84 278.531Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.974 260.053C534.31 261.549 543.859 266.04 552.54 267.082L554.185 253.371C545.964 252.385 536.736 251.048 526.626 249.584C494.214 244.891 452.735 238.885 406.297 238.885C340.913 238.885 285.885 253.832 239.647 266.392C238.601 266.676 237.56 266.959 236.523 267.24L240.14 280.567C241.052 280.32 241.966 280.072 242.883 279.822C289.266 267.226 342.775 249.584 406.297 249.584C451.625 249.584 491.653 255.377 523.974 260.053Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.355 423.084C310.756 423.084 240.759 347.971 240.759 252.431C240.759 156.891 310.756 86.4792 394.355 86.4792C477.953 86.4792 547.95 156.891 547.95 252.431C547.95 347.971 477.953 423.084 394.355 423.084ZM394.355 436.893C301.899 436.893 226.949 354.307 226.949 252.431C226.949 150.555 301.899 67.9687 394.355 67.9687C486.81 67.9687 561.76 150.555 561.76 252.431C561.76 354.307 486.81 436.893 394.355 436.893Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.872 92.6976C206.648 92.6976 242.963 103.308 270.253 130.99L280.087 123.288C250.444 93.2181 210.676 72.7214 166.872 72.7214C74.2439 72.7214 0.240241 155.048 0.240241 255.197C0.240241 355.347 74.2439 437.673 166.872 437.673C210.676 437.673 247.817 412.001 277.46 381.931L271.209 372.22C243.92 399.902 206.648 423.864 166.872 423.864C83.0706 423.864 14.0495 348.978 14.0495 255.197C14.0495 161.416 83.0706 92.6976 166.872 92.6976Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0068,
    cy: 25.0068,
    r: 25.0068,
    transform: "matrix(-1 0 0 1 554.185 209.712)",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.9686,
    cy: 25.9686,
    r: 25.9686,
    transform: "matrix(-1 0 0 1 236.523 220.827)",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M416.5 3.77728C427.422 0.136835 445.904 -3.27926 454.725 8.32783C472.018 31.0806 444.714 40.1818 437.433 45.6425C430.152 51.1032 374.635 69.3054 347.332 78.4066C320.029 87.5077 310.017 91.1481 300.916 88.4178C291.815 85.6875 288.175 77.4965 289.085 69.3054C289.995 61.1144 306.377 50.1931 315.478 45.6425C324.579 41.0919 402.849 8.32783 416.5 3.77728Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.553 53.1085C244.07 58.7758 257.036 70.0673 261.329 75.0046C272.277 103.985 226.553 99.4767 211.097 99.4767C195.641 99.4767 135.749 89.8167 108.701 82.0887C81.6524 74.3606 78.4324 53.1085 75.2124 40.2285C71.9924 27.3484 94.5325 23.4844 108.701 25.4164C122.869 27.3484 204.657 46.0245 226.553 53.1085Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingBuddyClosed);
export default __webpack_public_path__ + "static/media/writing-buddy-closed.997575d7160427b41332cd07c06cdce9.svg";
export { ForwardRef as ReactComponent };